import React, { FC } from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

type OptionEntity = {
	title: string;
	value: string;
};

const CATEGORIES: OptionEntity[] = [
	{ title: 'Practice', value: 'practice' },
	{ title: 'Theory', value: 'theory' },
];

const TAGS: OptionEntity[] = [
	{ title: 'HTML', value: 'HTML' },
	{ title: 'CSS', value: 'CSS' },
	{ title: 'SCSS', value: 'SCSS' },
	{ title: 'Javascript', value: 'Javascript' },
	{ title: 'React', value: 'React' },
	{ title: 'Exercises', value: 'Exercises' },
	{ title: 'REST API', value: 'REST API' },
	{ title: 'Redux', value: 'Redux' },
	{ title: 'Practice', value: 'Practice' },
	{ title: 'Tutorial', value: 'Tutorial' },
	{ title: 'Interview', value: 'Interview' },
	{ title: 'HR', value: 'HR' },
	{ title: 'Soft Skills', value: 'Soft Skills' },
];

const OCCUPATIONS: OptionEntity[] = [
	{ title: 'Frontend', value: 'frontend' },
	{ title: 'Interviews', value: 'interview' },
];

type OptionsDictinary = {
	[key: string]: OptionEntity[];
};

const OPTIONS: OptionsDictinary = {
	category: CATEGORIES,
	tags: TAGS,
	occupation: OCCUPATIONS,
};

type TagsProps = {
	label: string;
	required: boolean;
	defaultValue?: string[] | undefined;
	name: string;
	freeSolo?: boolean;
	className: string;
	// eslint-disable-next-line no-unused-vars
	onItemsChange: (value: string[] | undefined) => void;
};

const Tags: FC<TagsProps> = (props) => {
	const { label, required, defaultValue, name, freeSolo, onItemsChange } = props;
	const options: OptionEntity[] = OPTIONS[name];
	const onchange = (newValue: string[]) => {
		if (!freeSolo) {
			const change = newValue.map((option) => {
				const mappedValue = OPTIONS[name].find((item) => option === item.title);
				return mappedValue?.value || '';
			});
			onItemsChange(change);
		} else {
			onItemsChange(newValue);
		}
	};
	const renderTags = (value: string[], getTagProps: any) =>
		value.map((option, index) => (
			<Chip variant="outlined" label={option} {...getTagProps({ index })} />
		));

	return (
		<Autocomplete
			multiple
			id={`tags-${name}`}
			options={options.map((option) => option.title)}
			defaultValue={defaultValue}
			onChange={(e, newValue: any) => onchange(newValue)}
			freeSolo={freeSolo}
			size="small"
			renderTags={(value, getTagProps) => renderTags(value, getTagProps)}
			renderInput={(params) => (
				<TextField
					{...params}
					name={name}
					required={required}
					label={label}
					placeholder={label}
				/>
			)}
		/>
	);
};

Tags.defaultProps = {
	defaultValue: [],
	freeSolo: false,
};

export default Tags;
